import React from "react";
import { withTranslation } from "react-i18next";

const lang = window.lang;

const Description = (props) => {
  const { t } = props;

  return (
    <p
      className={
        lang === "en" ? "desc-react mt-3  mb-5" : "desc-react-a mt-3 mb-5"
      }
    >
      {t(props.description)}
    </p>
  );
};

export default withTranslation()(Description);
